import React from 'react'
import PropTypes from 'prop-types'

import Modal from 'component/utils/Modal'
import Row from 'component/utils/Row'
import Col from 'component/utils/Col'

import Close from 'images/close.svg'

const ErrorModal = ({ children, closeModal, translate }) => (
  <Modal
    closeModal={closeModal}
    size='md'
    className='tracking-monitor-errorSuccess'
  >
    <p>
      <img src={Close} />
    </p>
    <h3>
      <strong>{translate('modal.error.title')}</strong>
    </h3>

    {children}

    <Row className='margin-top-quadruple'>
      <Col xs={4} xsOffset={4}>
        <button
          className='button button-primary button-full'
          onClick={closeModal}
        >
          {translate('ok_button')}
        </button>
      </Col>
    </Row>
  </Modal>
)

ErrorModal.propTypes = {
  children: PropTypes.node,
  closeModal: PropTypes.func.isRequired,
  translate: PropTypes.func.isRequired,
}

export default ErrorModal
